<template>
    <div class="m15" ref="body" style="page-break-before: always;">
        <hr v-if="exibe === true"/>
        <h4 class="simulator-title loaded" v-if="exibe === true">Renda Mensal</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div class="row" v-if="exibe === true">
            <div class="col l3"></div>
            <div class="col l6 s12">
                <div style="text-align:center;">
                    <!-- <pie-chart ref="barchat" :myData="datachart" :myLabel="labelchart"/> -->
                    <pie-chart2 ref="barchat" :myData="datachart2" />
                </div>
                <div class="block" style="margin-top:15px;margin-bottom:15px;" v-if="mostra === true">
                    <div align="center">Renda Mensal</div>
                    <div class="total" align="center">Total: {{this.saldo}}</div>
                </div>
            </div>
            <div class="col l3"></div>
        </div>
        <div class="row" v-if="exibe === true">
        <div class="col l12 s12">
            <div class="row">
            <div class="texto" style="text-align:justify" v-if="!ocultarVinculoTrabalhista">
                Você possui uma <b style="font-weight:bold;">renda mensal</b> aproximada de {{this.saldo}} ({{this.saldo_extenso}}), provenientes de sua atividade profissional remunerada.</div>
            </div>
            <div class="row" v-if="autonomo !== 'R$ 0,00'">
            <div class="texto" style="text-align:justify">
                Dessa renda mensal você nos informa que {{this.porcentagem}}%, ou seja, {{this.autonomo}} ({{this.autonomo_extenso}}) são provenientes de atividade profissional sem vínculo trabalhista, portanto esse percentual da sua renda é vulnerável a um eventual afastamento de suas atividades, seja temporariamente ou de forma definitiva, em razão de um acidente ou doença.</div>
            </div>
            <div class="row" v-if="autonomo !== 'R$ 0,00'">
            <div class="texto" style="text-align:justify">
                É necessário portanto uma proteção dessa renda, já que em um eventual afastamento o seu padrão de vida e compromissos financeiros podem ser gravemente afetados.</div>
            </div>
            <div class="row" v-if="autonomo !== 'R$ 0,00'">
            <div class="texto" style="text-align:justify">
                A necessidade de cobertura em casos de um afastamento temporário, ou definitivo é de uma <b style="font-weight:bold;">renda mensal</b> de {{this.autonomo}} ({{this.autonomo_extenso}}).</div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import PieChart from '@/components/canvas-chart/PieChart'
    import PieChart2 from '@/components/canvas-chart/PieChart2'
    import Saudacao from './Saudacao'
    const extenso = require('extenso')
    export default {
        name:'FonteRenda',
        mixins: [utils],
        components: {
            PieChart,
            PieChart2,
            Saudacao
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
        },
        data () {
            return {
                db: [],
                options: {},
                image: null,
                autonomo: null,
                autonomo_extenso: null,
                porcentagem: null,
                extenso: null,
                fonte_renda:[],
                saldo:null,
                saldo_extenso: null,
                exibe: false,
                mostra: false,
                datachart: [],
                datachart2: [],
                labelchart: [],
                ocultarVinculoTrabalhista: false,
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',


                titulo: 'Renda Mensal',
            }
        },
        methods:{
            async plot()
            {

                if (! this.$refs.barchat) return '';

                const canvas = this.$refs.barchat.chart;

                if (canvas) {
                   this.image = canvas.toDataURL("image/png");
                }


                if (this.exibe === true) {

                    const tagImg = this.image ? `<img src="${this.image}" />` : '';

                    return `<div class="m15 page_logo" ref="body" id="renda" style="page-break-before: always;">
                       <div class="site"></div>
                        <h4 class="simulator-title loaded">${this.titulo}</h4>
                        ${this.$refs.saudacao.plot()}
                        <div class="grafico">
                        <div class="row" style="${this.datachart2.length > 1?'display:block;':'display:none;'}" style="padding-top: 200px;">
                            ${tagImg}
                            <div class="block" style="${this.mostra === true?'display:block;':'display:none;'}">
                                <div align="center">Renda Mensal</div>
                                <div class="total" align="center">Total: ${this.saldo}</div>
                            </div>

                        </div>
                        </div>
                        <div class="row" style="${this.mostra !== true ?'padding-top:10px;':'padding-top: 200px;'}">
                            <table>
                                <tr>
                                    <td width="100%" style="vertical-align: top;">
                                        <p style="font-size:18px;padding-bottom:30px; display: ${this.ocultarVinculoTrabalhista ? 'none' : 'block'}" >
                                            Você possui uma <b style="font-weight:bold;">renda mensal</b> aproximada de ${this.saldo} (${this.saldo_extenso}), provenientes de sua atividade profissional remunerada.</div>
                                        </p>

                                        <p style="font-size:18px;padding-bottom:30px;${this.autonomo === 'R$ 0,00'?'display:none;':'display:block;'}">
                                            Dessa renda mensal você nos informa que ${this.porcentagem}%, ou seja, ${this.autonomo} (${this.autonomo_extenso}) são provenientes de atividade profissional sem vínculo trabalhista, portanto esse percentual da sua renda é vulnerável a um eventual afastamento de suas atividades, seja temporariamente ou de forma definitiva, em razão de um acidente ou doença.</div>
                                        </p>
                                        <p style="font-size:18px;padding-bottom:30px;${this.autonomo === 'R$ 0,00'?'display:none;':'display:block;'}">
                                            É necessário portanto uma proteção dessa renda, já que em um eventual afastamento o seu padrão de vida e compromissos financeiros podem ser gravemente afetados.</div>
                                        </p>

                                        <p style="font-size:18px;padding-bottom:30px;${this.autonomo === 'R$ 0,00'?'display:none;':'display:block;'}">
                                            A necessidade de cobertura em casos de um afastamento temporário, ou definitivo é de uma <b style="font-weight:bold;">renda mensal</b> de ${this.autonomo} (${this.autonomo_extenso}).</div>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>`;
                }else{
                    return ''
                }
            },

            jsonToObject(j){
                if(j != undefined)
                return Object.keys(j).map(function(_) { return j[_]; })
            },

            async getData(){
                
                const { fontes_renda } = this.cliente;


                if(fontes_renda != null) {
                    this.fonte_renda = this.jsonToObject(fontes_renda.find(i => i.tipo == 'T'))
                }

                if(this.fonte_renda != undefined){

                    const rendimento_mensal = parseFloat(this.fonte_renda[6] ? this.fonte_renda[6] : 0);
                    const clt = rendimento_mensal * (parseFloat(this.fonte_renda[1] ? this.fonte_renda[1] : 0)/100);
                    const autonomo = rendimento_mensal * (parseFloat(this.fonte_renda[7] ? this.fonte_renda[7] : 0)/100);
                    const funcionario_publico = rendimento_mensal * (parseFloat(this.fonte_renda[8] ? this.fonte_renda[8] : 0)/100);

                    this.exibe = !(clt === 0 && autonomo === 0 && funcionario_publico === 0);

                    this.ocultarVinculoTrabalhista = (clt === 0 && funcionario_publico === 0);

                    const percent_autonomo = parseFloat(this.fonte_renda[7] ? this.fonte_renda[7] : 0)
                    const autonomoporcentagem = (parseFloat(this.fonte_renda[7] ? this.fonte_renda[7] : 0)/100)

                    if(fontes_renda != null) {
                        this.saldo = this.real(this.total(clt, autonomo, funcionario_publico))
                        this.saldo_extenso = this.currency(this.total(clt, autonomo, funcionario_publico))
                        this.porcentagem = percent_autonomo
                        this.extenso = this.currency(percent_autonomo)
                        //this.autonomo = this.real(this.total(clt, autonomo, funcionario_publico) * autonomoporcentagem)
                        this.autonomo = this.real(this.total(autonomo))
                        this.autonomo_extenso = this.currency(this.total(autonomo))
                        this.db.push(
                            rendimento_mensal,
                            clt,
                            autonomo,
                            funcionario_publico
                        )

                        const data = [
                            {name: 'CLT', value: clt},
                            {name: 'Autonomo\nLiberal', value: autonomo},
                            {name: 'Funcionário\nPublico', value: funcionario_publico}
                        ].filter(item => item.value !== 0)

                        const data2 = [
                            {label: 'CLT', value: clt},
                            {label: 'Autonomo\nLiberal', value: autonomo},
                            {label: 'Funcionário\nPublico', value: funcionario_publico}
                        ].filter(item => item.value !== 0)

                        this.labelchart = data.map(item => item.name)

                        this.datachart = data.map(item => item.value)

                        this.datachart2 = data2.reverse()

                        this.show(clt, autonomo, funcionario_publico)
                    }
                }

            },

            show (...args) {

                if (!args) return

                const diff = args.filter(item => item !== 0)
                if (diff.length === 0) {
                    this.mostra = false
                }
                if (diff.length === 1) {
                    this.mostra = false
                }
                if (diff.length > 1) {
                    this.mostra = true
                }
            },
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    display: block;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 100%;
    }
}
@media (min-width: 768px) and (max-width:938px){
    .block{
        margin-left: 210px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/FonteRenda.vue